import ProcessButton from '@/core/components/ProcessButton.vue';

import { defineComponent } from 'vue';
export default defineComponent({
  components: {
    ProcessButton,
  },
  data() {
    return {
      btnStatus: {
        success: false,
        loading: false,
        error: false,
      },
    };
  },
  methods: {
    resetStatus() {
      this.btnStatus.loading = false;
      this.btnStatus.success = false;
      this.btnStatus.error = false;
    },
    activeLoading() {
      this.resetStatus();
      this.btnStatus.loading = true;
    },
    activeError() {
      this.resetStatus();
      this.btnStatus.error = true;
    },
    activeSuccess() {
      this.resetStatus();
      this.btnStatus.success = true;
    },
  },
});
